import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {Point} from '@app/modules/svg/model/Point';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {MoveDrawer} from '@app/modules/svg/service/tool/draw/mode/MoveDrawer';
import {MoveDrawable} from '@app/modules/svg/service/tool/draw/type/MoveDrawable';
import {SquareRootView} from '@app/modules/svg/element/complex/cartesian/graphic/SquareRootView';

export class DrawSquareRoot extends MoveDrawer {
  protected createDrawableElement(position: Point): MoveDrawable {
    return new SquareRootView(
      this.drawTool.container,
      {overEvent: true, globalStyle: true},
      position,
      position
    );
  }

  public override start(call: boolean): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.SQUARE_ROOT_TOOL_ON);
    }
  }
  public override stop(call: boolean): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.SQUARE_ROOT_TOOL_OFF);
    }
  }

  public _new(): DrawSquareRoot {
    return new DrawSquareRoot(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.SQUARE_ROOT;
  }
}
